import { render, staticRenderFns } from "./RecetaPasosHandler.vue?vue&type=template&id=8256e63a&"
import script from "./RecetaPasosHandler.vue?vue&type=script&lang=js&"
export * from "./RecetaPasosHandler.vue?vue&type=script&lang=js&"
import style0 from "./RecetaPasosHandler.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports